function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "appleGradient",
  x1: 16.99,
  y1: 35.99,
  x2: 16.99,
  y2: 2,
  gradientTransform: "matrix(1, 0, 0, -1, 0, 36)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f452ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#832bc1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M33.32,29.47a7.2,7.2,0,0,1-2.17,2.85,7.11,7.11,0,0,1-2.39,1.24,14.8,14.8,0,0,1-4.11.43H9.35a14.8,14.8,0,0,1-4.11-.43,7.19,7.19,0,0,1-4.57-4.1A13.34,13.34,0,0,1,0,24.65H0V9.36H0A13.31,13.31,0,0,1,.67,4.54,7.19,7.19,0,0,1,5.24.44,14.8,14.8,0,0,1,9.35,0h15.3a14.8,14.8,0,0,1,4.11.43,7.19,7.19,0,0,1,4.57,4.1A13.34,13.34,0,0,1,34,9.36v15.3A13.31,13.31,0,0,1,33.32,29.47Z",
  fill: "url(#appleGradient)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.46,19.55A3.41,3.41,0,0,0,17,18.66a3.4,3.4,0,0,0-2.46.88,1.56,1.56,0,0,0-.45,1,12.7,12.7,0,0,0,.05,2.57c.09,1,.26,2.43.48,3.85a14.73,14.73,0,0,0,.4,1.94,1.92,1.92,0,0,0,2,1.18,1.92,1.92,0,0,0,2-1.18,14.62,14.62,0,0,0,.4-1.94c.22-1.41.39-2.8.48-3.85a12.82,12.82,0,0,0,.06-2.57A1.56,1.56,0,0,0,19.46,19.55Zm-5.24-4.79A2.78,2.78,0,1,0,17,12,2.78,2.78,0,0,0,14.22,14.76ZM17,3.78A12,12,0,0,0,13,27a.16.16,0,0,0,.21-.17c-.06-.41-.12-.82-.17-1.22a.41.41,0,0,0-.24-.32,10.42,10.42,0,1,1,8.32,0,.41.41,0,0,0-.24.32c-.05.4-.11.82-.17,1.22A.16.16,0,0,0,21,27,12,12,0,0,0,17,3.78Zm-.22,5.48a6.47,6.47,0,0,1,4.69,11.19.5.5,0,0,0-.16.39,11.78,11.78,0,0,1,0,1.36.16.16,0,0,0,.25.14,8,8,0,1,0-9,0,.16.16,0,0,0,.24-.14,11.17,11.17,0,0,1,0-1.37.49.49,0,0,0-.16-.39A6.47,6.47,0,0,1,16.75,9.26Z",
  fill: "#fff"
})));

function SvgApplePodcasts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplePodcasts);
export default __webpack_public_path__ + "static/media/apple-podcasts.73041537.svg";
export { ForwardRef as ReactComponent };